var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"painel-header"},[_c('h1',{staticClass:"painel-header__title"},[_vm._v("Painel de Controle | Sistemas de Telechamada")]),_c('button',{staticClass:"painel-header__logout",attrs:{"type":"button"},on:{"click":_vm.handleLogout}},[_vm._v(" Sair ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }